import { ActionIconComposition } from '@codeleap/web'
import { createStyles } from '@codeleap/styles'
import { StyleRegistry } from '../styles'

const createActionIconVariant = createStyles<ActionIconComposition>

export const ActionIconStyles = {
  default: createActionIconVariant(theme => ({
    touchableWrapper: {
      width: theme.size.large,
      height: theme.size.large,
      borderRadius: theme.radius.medium,
      ...theme.presets.center,
      backgroundColor: theme.colors.buttonHighlightPrimaryBgDefault,
      ...theme.border({
        color: theme.colors.buttonHighlightPrimaryBgDefault,
        width: theme.stroke.regular,
      }),
    },
    'touchableWrapper:pressable': {
      cursor: 'pointer',
    },
    'touchableWrapper:disabled': {
      cursor: 'not-allowed',
      backgroundColor: theme.colors.buttonHighlightPrimaryBgDisabled,
      ...theme.border({
        color: theme.colors.buttonHighlightPrimaryBgDisabled,
        width: theme.stroke.regular,
      }),
    },
    icon: {
      width: theme.values.iconSize[2],
      height: theme.values.iconSize[2],
      color: theme.baseColors.onPrimarySolid500Heading,
    },
    'icon:disabled': {
      color: theme.baseColors.onPrimarySolid500Caption,
    },
  })),
  small: createActionIconVariant(theme => ({
    touchableWrapper: {
      width: theme.size.medium,
      height: theme.size.medium,
      ...theme.spacing.padding(theme.stroke.regular),
      borderRadius: theme.radius.regular,
    },
    icon: {
      width: theme.values.iconSize[1],
      height: theme.values.iconSize[1],
    },
  })),
  large: createActionIconVariant(theme => ({
    touchableWrapper: {
      width: theme.size.large,
      height: theme.size.large,
      borderRadius: theme.radius.regular,
    },
    icon: {
      width: theme.values.iconSize[3],
      height: theme.values.iconSize[3],
    },
  })),
  largeish: createActionIconVariant(theme => ({
    touchableWrapper: {
      width: theme.size.largeish,
      height: theme.size.largeish,
      borderRadius: theme.radius.infinite,
    },
    icon: {
      width: theme.values.iconSize[3],
      height: theme.values.iconSize[3],
    },
  })),
  'xx-large': createActionIconVariant(theme => ({
    touchableWrapper: {
      width: theme.size['xx-large'],
      height: theme.size['xx-large'],
      borderRadius: theme.radius.infinite,
    },
    icon: {
      width: theme.values.iconSize[3],
      height: theme.values.iconSize[3],
    },
  })),
  regularSecondary: createActionIconVariant(theme => ({
    touchableWrapper: {
      backgroundColor: theme.colors.buttonHighlightSecondaryBgDefault,
      ...theme.border({
        color: theme.colors.buttonHighlightSecondaryBgDefault,
        width: theme.stroke.regular,
      }),
    },
    'touchableWrapper:disabled': {
      backgroundColor: theme.colors.buttonHighlightSecondaryBgDisabled,
      ...theme.border({
        color: theme.colors.buttonHighlightSecondaryBgDefault,
        width: theme.stroke.regular,
      }),
    },
    icon: {
      color: theme.colors.buttonHighlightSecondaryIconDefault,
    },
    'icon:disabled': {
      color: theme.colors.buttonHighlightSecondaryIconDisabled,
    },
  })),
  regularTerciary: createActionIconVariant(theme => ({
    touchableWrapper: {
      backgroundColor: theme.colors.buttonHighlightTerciaryBgDefault,
      ...theme.border({
        color: theme.colors.buttonHighlightTerciaryStrokeDefault,
        width: theme.stroke.regular,
      }),
    },
    'touchableWrapper:disabled': {
      backgroundColor: theme.colors.buttonHighlightTerciaryBgDisabled,
      ...theme.border({
        color: theme.colors.buttonHighlightTerciaryStrokeDisabled,
        width: theme.stroke.regular,
      }),
    },
    icon: {
      color: theme.colors.buttonHighlightTerciaryIconDefault,
    },
    'icon:disabled': {
      color: theme.colors.buttonHighlightTerciaryIconDisabled,
    },
  })),
  regularQuaternary: createActionIconVariant(theme => ({
    touchableWrapper: {
      backgroundColor: theme.colors.buttonHighlightQuaternaryBgDefault,
      ...theme.border({
        color: theme.colors.buttonHighlightQuaternaryBgDefault,
        width: theme.stroke.regular,
      }),
    },
    'touchableWrapper:disabled': {
      backgroundColor: theme.colors.buttonHighlightQuaternaryBgDisabled,
      ...theme.border({
        color: theme.colors.buttonHighlightQuaternaryBgDisabled,
        width: theme.stroke.regular,
      }),
    },
    icon: {
      color: theme.colors.buttonHighlightQuaternaryIconDefault,
    },
    'icon:disabled': {
      color: theme.colors.buttonHighlightQuaternaryIconDisabled,
    },
  })),
  neutralSecondary: createActionIconVariant(theme => ({
    touchableWrapper: {
      backgroundColor: theme.colors.buttonNeutralSecondaryBgDefault,
      ...theme.border({
        color: theme.colors.buttonNeutralSecondaryBgDefault,
        width: theme.stroke.regular,
      }),
    },
    'touchableWrapper:disabled': {
      backgroundColor: theme.colors.buttonNeutralSecondaryBgDisabled,
      ...theme.border({
        color: theme.colors.buttonNeutralSecondaryBgDefault,
        width: theme.stroke.regular,
      }),
    },
    icon: {
      color: theme.colors.buttonNeutralSecondaryIconDefault,
    },
    'icon:disabled': {
      color: theme.colors.buttonNeutralSecondaryIconDisabled,
    },
  })),
  neutralTerciary: createActionIconVariant(theme => ({
    touchableWrapper: {
      backgroundColor: theme.colors.buttonNeutralTerciaryBgDefault,
      ...theme.border({
        color: theme.colors.buttonNeutralTerciaryStrokeDefault,
        width: theme.stroke.regular,
      }),
    },
    'touchableWrapper:disabled': {
      backgroundColor: theme.colors.buttonNeutralTerciaryBgDisabled,
      ...theme.border({
        color: theme.colors.buttonNeutralTerciaryStrokeDisabled,
        width: theme.stroke.regular,
      }),
    },
    icon: {
      color: theme.colors.buttonNeutralTerciaryIconDefault,
    },
    'icon:disabled': {
      color: theme.colors.buttonNeutralTerciaryIconDisabled,
    },
  })),
  neutralQuaternary: createActionIconVariant(theme => ({
    touchableWrapper: {
      backgroundColor: theme.colors.buttonNeutralQuaternaryBgDefault,
      ...theme.border({
        color: theme.colors.buttonNeutralQuaternaryBgDefault,
        width: theme.stroke.regular,
      }),
    },
    'touchableWrapper:disabled': {
      backgroundColor: theme.colors.buttonNeutralQuaternaryBgDisabled,
      ...theme.border({
        color: theme.colors.buttonNeutralQuaternaryBgDisabled,
        width: theme.stroke.regular,
      }),
    },
    icon: {
      color: theme.colors.buttonNeutralQuaternaryIconDefault,
    },
    'icon:disabled': {
      color: theme.colors.buttonNeutralQuaternaryIconDisabled,
    },
  })),
  negativePrimary: createActionIconVariant(theme => ({
    touchableWrapper: {
      backgroundColor: theme.colors.buttonNegativePrimaryBgDefault,
      ...theme.border({
        color: theme.colors.buttonNegativePrimaryBgDefault,
        width: theme.stroke.regular,
      }),
    },
    'touchableWrapper:disabled': {
      backgroundColor: theme.colors.buttonNegativePrimaryBgDisabled,
      ...theme.border({
        color: theme.colors.buttonNegativePrimaryBgDefault,
        width: theme.stroke.regular,
      }),
    },
    icon: {
      color: theme.colors.buttonNegativePrimaryIconDefault,
    },
    'icon:disabled': {
      color: theme.colors.buttonNegativePrimaryIconDisabled,
    },
  })),
  negativeSecondary: createActionIconVariant(theme => ({
    touchableWrapper: {
      backgroundColor: theme.colors.buttonNegativeSecondaryBgDefault,
      ...theme.border({
        color: theme.colors.buttonNegativeSecondaryBgDefault,
        width: theme.stroke.regular,
      }),
    },
    'touchableWrapper:disabled': {
      backgroundColor: theme.colors.buttonNegativeSecondaryBgDisabled,
      ...theme.border({
        color: theme.colors.buttonNegativeSecondaryBgDefault,
        width: theme.stroke.regular,
      }),
    },
    icon: {
      color: theme.colors.buttonNegativeSecondaryIconDefault,
    },
    'icon:disabled': {
      color: theme.colors.buttonNegativeSecondaryIconDisabled,
    },
  })),
  negativeTerciary: createActionIconVariant(theme => ({
    touchableWrapper: {
      backgroundColor: theme.colors.buttonNegativeTerciaryBgDefault,
      ...theme.border({
        color: theme.colors.buttonNegativeTerciaryStrokeDefault,
        width: theme.stroke.regular,
      }),
    },
    'touchableWrapper:disabled': {
      backgroundColor: theme.colors.buttonNegativeTerciaryBgDisabled,
      ...theme.border({
        color: theme.colors.buttonNegativeTerciaryStrokeDisabled,
        width: theme.stroke.regular,
      }),
    },
    icon: {
      color: theme.colors.buttonNegativeTerciaryIconDefault,
    },
    'icon:disabled': {
      color: theme.colors.buttonNegativeTerciaryIconDisabled,
    },
  })),
  negativeQuaternary: createActionIconVariant(theme => ({
    touchableWrapper: {
      backgroundColor: theme.colors.buttonNegativeQuaternaryBgDefault,
      ...theme.border({
        color: theme.colors.buttonNegativeQuaternaryBgDefault,
        width: theme.stroke.regular,
      }),
    },
    'touchableWrapper:disabled': {
      backgroundColor: theme.colors.buttonNegativeQuaternaryBgDisabled,
      ...theme.border({
        color: theme.colors.buttonNegativeQuaternaryBgDisabled,
        width: theme.stroke.regular,
      }),
    },
    icon: {
      color: theme.colors.buttonNegativeQuaternaryIconDefault,
    },
    'icon:disabled': {
      color: theme.colors.buttonNegativeQuaternaryIconDisabled,
    },
  })),
  rounded: createActionIconVariant(theme => ({
    touchableWrapper: {
      borderRadius: theme.radius.infinite,
    },
  })),
  selected: createActionIconVariant(theme => ({
    touchableWrapper: {
      backgroundColor: theme.baseColors.neutralSolid200,
    },
  })),
  originalColor: createActionIconVariant(theme => ({
    icon: {
      color: 'unset',
    },
  })),
  normalize: createActionIconVariant(theme => ({
    touchableWrapper: {
      width: 'unset',
      height: 'unset',
      borderRadius: 'unset',
      ...theme.presets.center,
      backgroundColor: 'unset',
      padding: theme.spacing.value(0),
      ...theme.border({
        color: 'auto',
        width: 0,
      }),
    },
  })),
  'iconSize:1': createActionIconVariant(theme => ({
    icon: {
      width: theme.values.iconSize[1],
      height: theme.values.iconSize[1],
    },
  })),
  'iconSize:2': createActionIconVariant(theme => ({
    icon: {
      width: theme.values.iconSize[2],
      height: theme.values.iconSize[2],
    },
  })),
  'iconSize:3': createActionIconVariant(theme => ({
    icon: {
      width: theme.values.iconSize[3],
      height: theme.values.iconSize[3],
    },
  })),
  'iconSize:4': createActionIconVariant(theme => ({
    icon: {
      width: theme.values.iconSize[4],
      height: theme.values.iconSize[4],
    },
  })),
  'iconSize:5': createActionIconVariant(theme => ({
    icon: {
      width: theme.values.iconSize[5],
      height: theme.values.iconSize[5],
    },
  })),
  'iconSize:6': createActionIconVariant(theme => ({
    icon: {
      width: theme.values.iconSize[6],
      height: theme.values.iconSize[6],
    },
  })),
  pageHeader: createActionIconVariant(theme => ({
    touchableWrapper: {
      width: theme.size.largeish,
      height: theme.size.largeish,
    },
    icon: {
      width: theme.values.iconSize[1],
      height: theme.values.iconSize[1],
    },
  })),
  minimal: createActionIconVariant(theme => ({
    touchableWrapper: {
      backgroundColor: theme.colors.buttonNeutralQuaternaryBgDefault,
      ...theme.border({ color: 'transparent', width: 0 }),
    },
    'touchableWrapper:disabled': {
      backgroundColor: theme.colors.buttonNeutralQuaternaryBgDisabled,
      ...theme.border({ color: 'transparent', width: 0 }),
    },
    icon: {
      color: theme.colors.buttonHighlightSecondaryIconDefault,
    },
    'icon:disabled': {
      color: theme.colors.buttonHighlightQuaternaryIconDefault,
    },
  })),
  'color:textHeadingRegular': createActionIconVariant(theme => ({
    icon: {
      color: theme.colors.textHeadingRegular,
    },
  })),
}

StyleRegistry.registerVariants('ActionIcon', ActionIconStyles)
